/**
 * RTK store for app-publico (W8.2).
 * Wraps legacy reducers (still JS) via configureStore.
 * Preserves existing reducer shape: mapConfig, container, lote, imovel,
 * smartMap, publicSettings, arquivosDigitalizados, arquivosGeraisFinancas, logradouros.
 */
import { configureStore } from "@reduxjs/toolkit";
// @ts-ignore — legacy JS reducers, migrated in-place
import rootReducer from "../reducers";

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
